import i18n from 'i18next';
import LocizeBackend from 'i18next-locize-backend';
import { locizePlugin } from 'locize';
import locizeLastUsed from 'locize-lastused';
import { initReactI18next } from 'react-i18next';
import { i18nextPlugin } from 'translation-check';
import config from '../../../../config';

const locizeCommonOpts: {
  apiKey?: string | undefined;
  projectId: string;
  referenceLng: string;
} = {
  projectId: config.locize.projectID,
  referenceLng: config.locize.referenceLanguage,
};

const isProduction = process.env.NODE_ENV === 'production';

if (!isProduction) {
  // protection of accidentally adding api key in prod
  locizeCommonOpts.apiKey = config.locize.apiKey;
  i18n.use(locizeLastUsed);
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(i18nextPlugin)
  .use(locizePlugin)
  .use(LocizeBackend)
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    ns: ['common', 'crop-estimates-view', 'ranch-view'], // define available namespaces
    defaultNS: 'common', // define namespace that could be used without defining ns in getter options
    debug: false,
    fallbackLng: 'en',
    saveMissing: !isProduction,
    backend: {
      ...locizeCommonOpts,
    },
    locizeLastUsed: {
      ...locizeCommonOpts,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
